import React, { Component, Fragment } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import './style.scss';

export default ({ className, small }) => (
  <div className="loader">
    <CircularProgress size={small ? 30 : 60} className="loader-item" />
  </div>
);
